import { AlloxApiStatus, AlloxApiErrorCode } from '../constants';

export class AlloxApiError<T>  {

  public get message() { return this._message; }
  public get response() { return this._response; }

  constructor(
    public readonly status: AlloxApiStatus,
    public readonly errorCode: AlloxApiErrorCode,
    private readonly _message: string,
    private readonly _response: T,
  ) { }

}
